var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_4769",
    "data-name": "Raggruppa 4769",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.263,
    height: 18.263,
    viewBox: "0 0 18.263 18.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9619",
    "data-name": "Tracciato 9619",
    d: "M308.263,3.957A1.957,1.957,0,0,0,306.306,2h-14.35A1.957,1.957,0,0,0,290,3.957V19.611a.652.652,0,0,0,1.115.46l3.509-3.529a.651.651,0,0,1,.462-.192h11.221a1.957,1.957,0,0,0,1.957-1.957ZM295.218,7.87a1.3,1.3,0,1,1-1.3,1.3A1.3,1.3,0,0,1,295.218,7.87Zm3.914,0a1.3,1.3,0,1,1-1.3,1.3A1.3,1.3,0,0,1,299.132,7.87Zm3.914,0a1.3,1.3,0,1,1-1.3,1.3A1.3,1.3,0,0,1,303.045,7.87Z",
    transform: "translate(-290 -2)",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/News.563015da1b3ee0e4107514afd98cc7b1.svg";
export { ForwardRef as ReactComponent };